import { DealRequest } from '@/app/api/types';
import { UIDefinitionList } from '@/shared/ui/ui-definition-list';
import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SingleDealClarifications } from './single-deal-clarifications';
import { ClarificationModalRef } from '@/features/factor-request-clarification-modal/types';
import {
  getCurrency,
  getDealBuyerName,
  getDealSellerName,
  triada,
} from '@/app/helpers';

interface Props {
  data: DealRequest;
  openClarificationModal?: ClarificationModalRef['open'];
  internationalKind: boolean;
}

export const SingleDealFactorDetails: FC<Props> = ({
  data,
  openClarificationModal,
  internationalKind,
}) => {
  const { t } = useTranslation();
  const debtorLabel =
    data.debtorTin === data?.buyer?.tin ? t('buyer') : t('supplier');

  return (
    <Box>
      {data.clarifications.length > 0 && (
        <>
          <Typography variant='h5' mt={2}>
            {t('clarifications')}
          </Typography>
          <SingleDealClarifications
            deal={data}
            sx={{ my: 2 }}
            openClarificationModal={openClarificationModal}
          />
        </>
      )}

      <Grid container>
        <Grid xs={12} md={6} item>
          <UIDefinitionList
            term={t('supplier')}
            description={getDealSellerName(data)}
            termSx={{
              color: 'primary.main',
            }}
            descriptionSx={{
              fontSize: 14,
              fontWeight: 600,
            }}
          />
        </Grid>
        <Grid xs={12} md={6} item>
          <UIDefinitionList
            termSx={{
              color: 'primary.main',
            }}
            descriptionSx={{
              fontSize: 14,
              fontWeight: 600,
            }}
            term={t('buyer')}
            description={getDealBuyerName(data)}
          />
        </Grid>
      </Grid>

      <Divider sx={{ my: 2.5 }} />

      <Stack direction='row' spacing={2}>
        <UIDefinitionList
          termSx={{
            color: 'primary.main',
          }}
          descriptionSx={{
            fontSize: 14,
            fontWeight: 600,
          }}
          term={t('factor_will_paid_by')}
          description={debtorLabel}
        />
        <UIDefinitionList
          termSx={{
            color: 'primary.main',
          }}
          descriptionSx={{
            fontSize: 14,
            fontWeight: 600,
          }}
          term={`${
            internationalKind
              ? t('createDealForm:invoice_sum')
              : t('sum_according_to_invoice')
          }, ${t(getCurrency(data.currency)).toLowerCase()}`}
          description={triada(data.contractAmount)}
        />
        <UIDefinitionList
          termSx={{
            color: 'primary.main',
          }}
          descriptionSx={{
            fontSize: 14,
            fontWeight: 600,
          }}
          term={
            t('buyers_debt') +
            `, ${t(getCurrency(data.currency)).toLowerCase()}`
          }
          description={triada(data.buyerDebtAmount)}
        />
        <UIDefinitionList
          termSx={{
            color: 'primary.main',
          }}
          descriptionSx={{
            fontSize: 14,
            fontWeight: 600,
          }}
          term={t('contract_payment_due_date')}
          description={data.contractPaymentDueDate}
        />
        {/* <UIDefinitionList
          termSx={{
            color: 'primary.main',
          }}
          descriptionSx={{
            fontSize: 14,
            fontWeight: 600,
          }}
          term={t('financial_receipt_date')}
          description={data.paymentDueDate}
        /> */}
      </Stack>
    </Box>
  );
};
